module.exports = __webpack_public_path__ + "staticcomp/img/content_2.7ecf0f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/content_2.jpg
// module id = eKn+
// module chunks = 39